import { Venues } from "../../components/venues";

export function VenuesPage() {
  return <Venues />;
}
